namespace GeniuzPOS.InitialData {
    export enum TimeFg {
        alltimedy = 0,
        chtime = 1
    }
    Serenity.Decorators.registerEnumType(TimeFg, 'GeniuzPOS.InitialData.TimeFg');
}
